import { useEffect } from "react"
import React from "react"
import { Outlet, useNavigate } from "react-router-dom"
import { useViewerMaybe } from "@/authentication/ViewerProvider"
import { rootPath } from "../org-admins-paths"

export const RequireUserSignedOut = () => {
  const navigate = useNavigate()
  const { viewer } = useViewerMaybe()

  useEffect(() => {
    if (viewer) {
      navigate(rootPath({}))
    }
  }, [viewer, navigate])

  return <Outlet />
}
